import PowerRangeRequests from '../../server/powerRange';
import { addLoading, removeLoading } from './loading';

export const getListPowerRange = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    const result = await PowerRangeRequests.getListPowerRange(limit, skip, search, orderBy, field);
    return result;
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createPowerRange = newPowerRange => async (dispatch) => {
  dispatch(addLoading());
  try {
    await PowerRangeRequests.createPowerRange(newPowerRange);
  } finally {
    dispatch(removeLoading());
  }
};

export const updatePowerRange = updPowerRange => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await PowerRangeRequests.updatePowerRange(updPowerRange);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};
